// extracted by mini-css-extract-plugin
export default {"container":"styles_container__lI5ol","letter":"styles_letter__p9Uta"};